<template>
  <section>
    <slot />
    <InAppAnnouncementTrigger />
  </section>
</template>

<script>
import InAppAnnouncementTrigger from '@/modules/announcement/components/stateful/InAppAnnouncementTrigger.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'AppLayout',
  components: {
    InAppAnnouncementTrigger
  }
};
</script>
